import { Box, Text } from 'grommet'
import DisplacementResults from './DisplacementResults'
import EISResults from './EISResults'
import Plotter from './Plotter'
import ReactionResults from './ReactionResults'

function ResultsDisplay(props) {
  return (
    <Box>
        <Box justify='center' align='center'>
            <h1>2Frame</h1>
            <Text>Programa de análise de pórticos planos</Text>
            <h2>Dados e informações da análise:</h2>
        </Box>
        <Box pad='xsmall'>
            <Text>Tipo de análise: {parseInt(props.type)+1}ª ordem</Text>
            <Text>Numero de nós: {props.nNodes}</Text>
            <Text>Numero de barras: {props.nBar}</Text>
        </Box>
        <Box justify='center' align='center' pad='xsmall'>
            <ReactionResults results={props.results.R} nNodes={props.nNodes} />
            <DisplacementResults results={props.results.D} nNodes={props.nNodes} />
            <EISResults results={props.results.EIS} nNodes={props.nBar} />
        </Box>
        <Box justify='center' align='center' pad='xsmall'>
            <Plotter data={props.diagrams} />
        </Box>
        <Box justify='center' align='center' pad='xsmall'>
            <Text>Os resultados aqui apresentados devem ser utilizados apenas para fins de informação.</Text>
            <Text>O usuário é o total responsável pela interpretação, calculo e uso dos resultados expostos.</Text>
        </Box>
    </Box>
  )
}

export default ResultsDisplay